/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_No_Record_SelectedInputs */

const en_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No record selected`)
};

const fr_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun enregistrement selectionne`)
};

const de_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Datensatz ausgewählt`)
};

const it_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun record selezionato`)
};

const ru_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись не выбрана`)
};

const es_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún registro seleccionado`)
};

const zh_cn2_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择记录`)
};

const ja_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードが選択されていません`)
};

const hi_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई रिकॉर्ड चयनित नहीं हुआ`)
};

const pt_pt2_explorer_info_no_record_selected = /** @type {(inputs: Explorer_Info_No_Record_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro selecionado`)
};

/**
* | output |
* | --- |
* | "No record selected" |
*
* @param {Explorer_Info_No_Record_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_no_record_selected = /** @type {((inputs?: Explorer_Info_No_Record_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_No_Record_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_no_record_selected(inputs)
	if (locale === "de") return de_explorer_info_no_record_selected(inputs)
	if (locale === "it") return it_explorer_info_no_record_selected(inputs)
	if (locale === "ru") return ru_explorer_info_no_record_selected(inputs)
	if (locale === "es") return es_explorer_info_no_record_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_no_record_selected(inputs)
	if (locale === "ja") return ja_explorer_info_no_record_selected(inputs)
	if (locale === "hi") return hi_explorer_info_no_record_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_no_record_selected(inputs)
	return en_explorer_info_no_record_selected(inputs)
});